import React from 'react'
import './MoreTalent.css'

import { Link } from 'react-router-dom';
import { DEFAULT_PROFILE_IMAGE, photoSource } from '../../../../util/ModelPhotos';

const MoreTalent = ({prev,next}) => {
    const previousPhoto = photoSource(prev?.photo) || DEFAULT_PROFILE_IMAGE;
    const nextPhoto = photoSource(next?.photo) || DEFAULT_PROFILE_IMAGE;

    return (
        <>
            <div className="more-talent">
                <div className="mt-left">
                    <Link to={prev['link']}>
                        <span>
                            <div className="mt-info">
                                <div className="mt-name">{prev['name']}</div>
                                <div className="mt-city">{prev['city']}</div>
                            </div><div className="mt-photo"
                                       style={{ backgroundImage:`url(${previousPhoto})`}}>
                            </div>
                        </span>
                    </Link>
                </div><div className="mt-right">
                    <Link to={next['link']}>
                        <span>
                            <div className="mt-photo"
                                style={{ backgroundImage:`url(${nextPhoto})`}}>
                            </div><div className="mt-info">
                                <div className="mt-name">{next['name']}</div>
                                <div className="mt-city">{next['city']}</div>
                            </div>
                        </span>
                    </Link>
                </div>
            </div>
        </>
    )

}

export default MoreTalent;